import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LEDGER_CATEGORIES, PAYMENT_METHODS } from "@/lib/sections";

function Field({ label, className = "", children }) {
  return <div className={`space-y-1.5 ${className}`}><Label>{label}</Label>{children}</div>;
}

function OptionSelect({ testid, value, onChange, options }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="min-h-[44px]"><SelectValue /></SelectTrigger>
      <SelectContent>
        {options.map((c) => <SelectItem key={c.value} value={c.value}>{c.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

const ENTRY_TYPES = [{ value: "income", label: "Income" }, { value: "expense", label: "Expense" }];

export default function LedgerDialog({ open, onOpenChange, form, setForm, onSave }) {
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  const setInput = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="ledger-dialog">
        <DialogHeader><DialogTitle style={{ fontFamily: "Outfit" }}>New ledger entry</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Date"><Input type="date" data-testid="ledger-date" value={form.entry_date} onChange={setInput("entry_date")} className="min-h-[44px]" /></Field>
          <Field label="Type"><OptionSelect testid="ledger-type" value={form.entry_type} onChange={set("entry_type")} options={ENTRY_TYPES} /></Field>
          <Field label="Payer / Source" className="col-span-2"><Input data-testid="ledger-payer" value={form.payer} onChange={setInput("payer")} className="min-h-[44px]" /></Field>
          <Field label="Category"><OptionSelect testid="ledger-category" value={form.category} onChange={set("category")} options={LEDGER_CATEGORIES} /></Field>
          <Field label="Method"><OptionSelect testid="ledger-method" value={form.method} onChange={set("method")} options={PAYMENT_METHODS} /></Field>
          <Field label="Amount (€)" className="col-span-2"><Input type="number" step="0.01" data-testid="ledger-amount" value={form.amount} onChange={setInput("amount")} className="min-h-[44px]" /></Field>
          <Field label="Notes" className="col-span-2"><Textarea data-testid="ledger-notes" value={form.notes} onChange={setInput("notes")} rows={2} /></Field>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="ledger-cancel">Cancel</Button>
          <Button onClick={onSave} data-testid="ledger-save">Save entry</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
